@if (isLoading()) {
  <app-shimmer-effect />
} @else {
  <section class="page-heading">
    <div>
      <h4>{{ student()?.payload?.first_name }} {{ student()?.payload?.last_name }}</h4>
      <small>See details of student</small>
    </div>

    <div class="btn-container">
      @if (schoolAdmins.includes(loggedUserRole ?? '')) {
        <button (click)="openAssignClass()" class="button first-button">
          <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.2454 13.7615C2.98239 13.6067 2.77079 13.3927 2.6106 13.1195C2.4504 12.8464 2.37031 12.54 2.37031 12.2003V7.42624L0.466189 6.33772C0.315003 6.24613 0.199459 6.13636 0.119558 6.00842C0.0398525 5.88048 0 5.73837 0 5.58211C0 5.42564 0.0398525 5.28284 0.119558 5.15369C0.199459 5.02434 0.315003 4.91387 0.466189 4.82228L8.67458 0.197038C8.81069 0.12915 8.94669 0.0793375 9.0826 0.0476027C9.21852 0.0158679 9.36128 0 9.5109 0C9.66052 0 9.80319 0.0158679 9.9389 0.0476027C10.0748 0.0793375 10.2061 0.128948 10.3328 0.196435L19.5488 5.31969C19.6884 5.40988 19.7986 5.52356 19.8793 5.66074C19.9598 5.79813 20 5.94636 20 6.10543V12.7351C20 12.8795 19.9519 13.0006 19.8558 13.0984C19.7596 13.196 19.6405 13.2449 19.4986 13.2449C19.3564 13.2449 19.2387 13.196 19.1455 13.0984C19.0524 13.0006 19.0059 12.8795 19.0059 12.7351V6.1687L16.6512 7.42624V12.2003C16.6512 12.54 16.5711 12.8464 16.4109 13.1195C16.2507 13.3927 16.0341 13.6067 15.7611 13.7615L10.3378 16.7822C10.2078 16.8641 10.0748 16.9209 9.9389 16.9524C9.80319 16.9841 9.66052 17 9.5109 17C9.36128 17 9.21852 16.9841 9.0826 16.9524C8.94669 16.9209 8.80873 16.8641 8.6687 16.7822L3.2454 13.7615ZM9.23976 10.1194C9.33514 10.181 9.42669 10.2119 9.51442 10.2119C9.60236 10.2119 9.6991 10.181 9.80465 10.1194L17.9032 5.58L9.80465 1.09334C9.6991 1.03148 9.60236 1.00055 9.51442 1.00055C9.42669 1.00055 9.33514 1.03148 9.23976 1.09334L1.12743 5.58L9.23976 10.1194ZM9.21714 15.9386C9.31252 16.0005 9.40789 16.0314 9.50326 16.0314C9.59863 16.0314 9.6991 16.0005 9.80465 15.9386L15.3181 12.8517C15.4386 12.7848 15.5252 12.6985 15.5781 12.5929C15.6308 12.4872 15.6571 12.3572 15.6571 12.2027V8.03031L10.3402 10.9853C10.2101 11.0568 10.0768 11.1084 9.94007 11.1401C9.80358 11.1718 9.66052 11.1877 9.5109 11.1877C9.36128 11.1877 9.21891 11.1718 9.08378 11.1401C8.94865 11.1084 8.81607 11.0568 8.68604 10.9853L3.36467 8.0056V12.2027C3.36467 12.3367 3.39101 12.4616 3.44369 12.5775C3.49637 12.6934 3.58293 12.7848 3.70337 12.8517L9.21714 15.9386Z"
              fill="white" />
          </svg>

          <p>Assign to Class</p>
        </button>
      }

      @if (admins.includes(loggedUserRole ?? '')) {
        <button (click)="openAssignFee()" class="secondary-button">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="6" width="20" height="12" rx="2" stroke="white" stroke-width="1.5" />
            <circle cx="12" cy="12" r="2.5" stroke="white" stroke-width="1.5" />
            <path d="M6 9H6.01M18 15H18.01" stroke="white" stroke-width="2" stroke-linecap="round" />
          </svg>

          <p>Assign Fee</p>
        </button>
      }
    </div>
  </section>

  <section class="level-container">
    <div class="box-one">
      <div class="student-name">

        <div class="blue">
          <div
            class="name">{{ Helpers.getInitials((student()?.payload?.first_name ?? 'a') + ' ' + (student()?.payload?.last_name ?? 'a')) }}
          </div>
        </div>

        <div class="info-child">
          <div>
            <h6 class="lighter-color">Student ID</h6>
          </div>

          <div>
            <p>{{ student()?.payload?.public_id }}</p>
          </div>
        </div>

        <div class="info-child">
          <div>
            <h6 class="lighter-color">Gender</h6>
          </div>
          <div>
            <p>{{ Helpers.toSentenceCase(student()?.payload?.sex) }}</p>
          </div>
        </div>

        @if (studentEnrollment()?.payload?.length) {
          <div class="info-child">
            <div>
              <h6 class="lighter-color">Level</h6>
            </div>
            <div>
              <p>{{ studentEnrollment()?.payload?.[0]?.level_name ?? 'None Assigned' }}</p>
            </div>
          </div>

          <div class="info-child">
            <div>
              <h6 class="lighter-color">Class</h6>
            </div>

            <div>
              <p>{{ studentEnrollment()?.payload?.[0]?.class_name }}</p>
            </div>
          </div>
        }

      </div>
    </div>

    <div class="box-two">
      <div class="personal-information">

        <h4>Personal Information</h4>

        <div class="info-child">
          <div>
            <h6 class="lighter-color">FULL NAME</h6>
            <p>{{ student()?.payload?.first_name }} {{ student()?.payload?.last_name }}</p>
          </div>
          <div>
            <h6 class="lighter-color">DATE OF BIRTH</h6>
            <p>{{ Helpers.formatDate(student()?.payload?.date_of_birth) }}</p>
          </div>
        </div>

        <div class="info-child">
          <div>
            <h6 class="lighter-color">GENDER</h6>
            <p>{{ student()?.payload?.sex }}</p>
          </div>

          <div>
            <h6 class="lighter-color">ENROLLED DATE</h6>
            <p>{{ Helpers.formatDate(student()?.payload?.admission_date) }}</p>
          </div>
        </div>

      </div>

      @if (schoolAdmins.includes(loggedUserRole ?? '')) {
        <div class="personal-information">

          <h4>Guardian / Parent Information</h4>

          <div class="info-child">
            <div>
              <h6 class="lighter-color">GUARDIAN NAME</h6>
              <p>{{ student()?.payload?.parent_name }}</p>
            </div>

            <div>
              <h6 class="lighter-color">EMAIL</h6>
              <p>{{ student()?.payload?.parent_email }}</p>
            </div>
          </div>

          <div class="info-child">
            <div>
              <h6 class="lighter-color">PHONE NUMBER</h6>
              <p>{{ student()?.payload?.parent_phone }}</p>
            </div>
          </div>
        </div>
      }

      @if (studentEnrollment()?.payload?.length) {
        <div class="academic-Information">

          <h4>Academic Information</h4>

          <div class="info-level">
            <div>
              <h6 class="lighter-color">LEVEL</h6>
              <p>{{ studentEnrollment()?.payload?.[0]?.level_name }}</p>
            </div>

            <div>
              <h6 class="lighter-color">CLASS</h6>
              <p>{{ studentEnrollment()?.payload?.[0]?.level_name }}{{ studentEnrollment()?.payload?.[0]?.class_name }}</p>
            </div>

          </div>

          @if (levelSubjects()?.payload?.length) {
            <div class="info-level-1">
              <div>
                <h6 class="lighter-color subject-name">SUBJECTS ({{ levelSubjects()?.payload?.length }})</h6>

                <div class="subject">

                  @for (s of levelSubjects()?.payload; track s.id) {
                    <p>{{ s.subject_name }}</p>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }

      <section class="table-content">

        <h4>Tuition & Fees</h4>

        <div class="filters">
          <input (input)="getStudentFees('search', search)" [(ngModel)]="search" type="search" name="search" id="search"
                 placeholder="Search fee name, username...">

          <div>

            <select (change)="getStudentFees('academic_year_id', academicYearId)" [(ngModel)]="academicYearId"
                    name="academicYearId" id="academicYearId">
              <option value="" hidden disabled>Select an academic year</option>
              <option value="">All academic years</option>

              @for (a of academicYears()?.payload; track $index) {
                <option [value]="a.id">{{ a.name }}</option>
              }
            </select>
          </div>
        </div>

        <div class="table-wrapper">
          <table>
            <thead>
            <tr>
              <th>Name</th>
              <th>Total Billed</th>
              <th>Due Date</th>
              <th>Status</th>
              <th class="options-column">Action</th>
            </tr>
            </thead>

            <tbody>
              @if (isFiltering()) {
                <tr>
                  <td colspan="5">
                    <app-loading-indicator />
                  </td>
                </tr>
              } @else {

                @if (!studentFees()?.payload?.length) {
                  <tr>
                    <td colspan="5" class="empty">
                      <app-not-found-error>
                        NO FEES FOUND
                      </app-not-found-error>
                    </td>
                  </tr>
                } @else {

                  @for (u of studentFees()?.payload; track u.id) {
                    <tr>
                      <td>
                        {{ u.fee_name }}
                      </td>

                      <td class="total-billed">
                        GH₵{{ u.final_amount }}
                      </td>

                      <td>
                        {{ Helpers.formatDate(u.due_date) }}
                      </td>

                      <td class="status">
                        <p [ngClass]="u.status">
                          {{ Helpers.replaceUnderscore(u.status) }}
                        </p>
                      </td>

                      <td class="options-column">
                        <app-action-button>
                          <button class="menu-item" (click)="selectStudentFee(u)">View details</button>
                          @if (admins.includes(loggedUserRole ?? '')) {
                            <button class="menu-item" (click)="openRecordPayment(u)">Record Payment</button>
                          }
                        </app-action-button>
                      </td>
                    </tr>
                  }

                }
              }
            </tbody>
          </table>
        </div>

        <app-pagination
          [page]="studentFees()?.pagination?.page ?? 0"
          [size]="studentFees()?.pagination?.size ?? 10"
          [totalElements]="studentFees()?.pagination?.totalElements ?? 0"
          [totalPages]="studentFees()?.pagination?.totalPages ?? 0"
          [first]="studentFees()?.pagination?.first ?? true"
          [last]="studentFees()?.pagination?.last ?? false"
          [hasNext]="studentFees()?.pagination?.hasNext ?? false"
          [hasPrevious]="studentFees()?.pagination?.hasPrevious ?? false"
          (pageChange)="loadPage($event)">
        </app-pagination>
      </section>

      <div class="student-attendance">
        <h4>Attendance</h4>

        <div class="filters">
          <select (change)="onAttendanceAcademicYearChange()" [(ngModel)]="attendanceAcademicYearId"
                  name="attendanceAcademicYearId" id="attendanceAcademicYearId">
            <option value="" hidden disabled>Select an academic year</option>

            @for (a of academicYears()?.payload; track $index) {
              <option [value]="a.id">{{ a.name }}</option>
            }
          </select>

          <div>
            <select (change)="getAttendance()" [(ngModel)]="attendanceTermId" name="attendanceTermId"
                    id="attendanceTermId">
              <option value="" hidden disabled>Select an academic term</option>

              @for (t of academicTerms()?.payload; track $index) {
                <option [value]="t.id">{{ t.term_name }}</option>
              }
            </select>
          </div>

        </div>

        @if (attendanceReports() !== null && academicTerms()?.payload?.length) {

          <div class="attendance-stats">
            <div class="attendance-card present">
              <h2>{{ attendanceSummary().present }}</h2>
              <small>Present</small>
            </div>

            <div class="attendance-card absent">
              <h2>{{ attendanceSummary().absent }}</h2>
              <small>Absent</small>
            </div>

            <div class="attendance-card no-record">
              <h2>{{ attendanceSummary().noRecord }}</h2>
              <small>No record taken</small>
            </div>

            <div class="attendance-card total">
              <h2>{{ attendanceSummary().total }}</h2>
              <small>Total</small>
            </div>

          </div>

          <div class="attendance-rate">
            <div class="attendance-header">
              <small>Attendance Rate</small>

              <small>{{ attendanceSummary().rate }}%</small>
            </div>

            <div class="attendance-range">
              <div [style.width.%]="attendanceSummary().rate"></div>
            </div>

            <small>{{ selectedTermName }} ⋅ {{ selectedAcademicYearName }}</small>
          </div>

          <div class="attendance-legend">
            <div class="legend">
              <div class="present"></div>
              <small>Present</small>
            </div>

            <div class="legend">
              <div class="absent"></div>
              <small>Absent</small>
            </div>

            <div class="legend">
              <div class="no-record"></div>
              <small>No record</small>
            </div>
          </div>

          <div class="attendance-container">
            <app-calender [attendance]="attendanceReports()" [attendanceDays]="leaveDays"
                          [termStartDate]="attendanceTermStartDate"
                          [termEndDate]="attendanceTermEndDate"></app-calender>
          </div>
        } @else {
          <div class="no-history">
            <h6>ADJUST FILTERS TO RETRIEVE ATTENDANCE RECORDS</h6>
          </div>
        }
      </div>

    </div>
  </section>

  <section [class.show]="setPaymentDetail()" class="slider">
    <div class="bg" (click)="setPaymentDetail.set(false)"></div>

    <div class="slider-content">
      <div class="slider-heading">
        <div>
          <h5>{{ selectedStudentFee.fee_name }}</h5>
          <small>{{ selectedStudentFee.public_id }}</small>
        </div>

        <div class="status">
          <p [ngClass]="selectedStudentFee.status">{{ Helpers.replaceUnderscore(selectedStudentFee.status) }}</p>
        </div>
      </div>

      @if (selectedStudentFee.superseded_by_enrollment_id) {
          <h4 class="student-transferred">Student has been transferred to a new class. This fee is no longer applicable.</h4>
      }

      <div [ngClass]="selectedStudentFee.status" class="amount-paid">
        <h6>FINAL AMOUNT</h6>

        @if (selectedStudentFee.status === 'WAIVED') {
          <h2>GH₵0.00</h2>
        } @else {
          <h2>GH₵{{ selectedStudentFee.final_amount }}</h2>
        }
      </div>

      <div class="transaction-info">
        <h6>FEE DETAILS</h6>

        <div class="transaction-container">
          <div>
            <small>Academic Year</small>
            <p>{{ selectedStudentFee.academic_year_name }}</p>
          </div>

          <div>
            <small>Term</small>
            <p>{{ selectedStudentFee.term_name }}</p>
          </div>

          <div>
            <small>Due Date</small>
            <p>{{ Helpers.formatDate(selectedStudentFee.due_date) }}</p>
          </div>

        </div>
      </div>

      <div class="fee-summary">
        <h6>AMOUNT BREAKDOWN</h6>

        <div class="transaction-container">

          <div>
            <small>Billed Amount</small>
            <p>GH₵{{ selectedStudentFee.original_amount | number: '1.2-2' }}</p>
          </div>

          <div>
            <small>Discount</small>
            <p>{{ (Number(selectedStudentFee.discount_amount) * 100 / Number(selectedStudentFee.original_amount)) | number: '1.0-2' }}
              %</p>
          </div>

          <div>
            <small>Adjustment Amount</small>
            <p>
              GH₵{{ (Number(selectedStudentFee.adjustment_amount) > 0) ? '+' : '' }}{{ selectedStudentFee.adjustment_amount }}</p>
          </div>

          <div>
            <small>Amount Paid</small>
            <p>GH₵{{ studentFeePayments()?.payload?.[0]?.student_fee_amount_paid ?? 0.00 }}</p>
          </div>

          <div>
            <small>Remaining Balance</small>
            <p>
              GH₵{{ studentFeePayments()?.payload?.[0]?.student_fee_remaining_balance ?? selectedStudentFee.final_amount }}</p>
          </div>

          @if (selectedStudentFee.adjustment_amount !== '0.00') {
            <div>
              <small>Adjustment Reason</small>
              <p>{{ selectedStudentFee.adjustment_reason }}</p>
            </div>
          }

          @if (selectedStudentFee.waived_by) {
            <div>
              <small>Waived</small>
              <p>Yes</p>
            </div>

            <div>
              <small>Waived Reason</small>
              <p>{{ selectedStudentFee.waiver_reason }}</p>
            </div>

            <div>
              <small>Waived By</small>
              <p>{{ waivedBy()?.payload?.first_name ?? '' }} {{ waivedBy()?.payload?.last_name ?? '' }}</p>
            </div>
          }


        </div>
      </div>

      @if (studentFeePayments()?.payload?.length) {
        <div class="payment-history">
          <h6>PAYMENT HISTORY</h6>

          <div class="payment-history-container">
            @for (p of studentFeePayments()?.payload; track $index) {
              <div class="payment-row">
                <div class="check-icon">
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.8222 3.24658L4.87005 9.19868L2.16455 6.49318" stroke="#15803D"
                          stroke-width="1.35275" />
                  </svg>
                </div>

                <div class="payment-details">
                  <p>GH₵{{ p.amount | number: '1.2-2' }}</p>
                  <small>{{ p.public_id }}</small>
                </div>

                <div class="method">
                  <div class="role"><p
                    [ngClass]="p.payment_method">{{ Helpers.capitalizeWords(Helpers.replaceUnderscore(p.payment_method)) }}</p>
                  </div>
                  <small>{{ Helpers.formatDate(p.payment_date) }}</small>
                </div>
              </div>
            }
          </div>
        </div>
      }

      @if (!selectedStudentFee.superseded_by_enrollment_id) {
        <div class="button-container">

        @if (admins.includes(loggedUserRole ?? '') && editStatuses.includes(selectedStudentFee.status)) {
          <button (click)="setDiscount.set(true)" class="button discount" type="button">
            <svg viewBox="0 0 1024 1024" fill="#fff" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 stroke="#fff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M361.45 1023.91c-14.34 0-28.682-5.454-39.586-16.358L16.458 702.148c-21.84-21.84-21.84-57.348-0.016-79.172l441.16-441.158c20.48-20.48 59.956-31.526 88.092-24.636l206.536 50.646c24.588 6.062 49.332 27.854 60.19 53.004a7.998 7.998 0 0 1-4.17 10.514c-4.032 1.75-8.78-0.11-10.514-4.17-8.716-20.2-29.932-39.024-49.318-43.804L541.88 172.726c-22.886-5.624-56.3 3.75-72.968 20.402L27.754 634.288c-7.516 7.514-11.638 17.542-11.638 28.26 0 10.732 4.138 20.762 11.654 28.292l305.404 305.404c15.592 15.576 40.976 15.576 56.566-0.016l441.126-441.142c16.67-16.668 25.994-50.098 20.386-72.984l-37.336-152.266a8 8 0 0 1 5.858-9.686 8.008 8.008 0 0 1 9.672 5.876l37.336 152.264c7.014 28.588-3.796 67.298-24.606 88.106L401.05 1007.552c-10.92 10.906-25.274 16.358-39.6 16.358z"
                  fill=""></path>
                <path
                  d="M663.934 423.986c-16.386 0-32.76-6.232-45.224-18.7-24.964-24.962-24.964-65.564-0.016-90.512 21.95-21.95 56.348-25.026 81.764-7.28a65.05 65.05 0 0 1 8.748 7.234 7.994 7.994 0 0 1 0.062 11.31c-3.11 3.138-8.17 3.186-11.308 0.078a48.916 48.916 0 0 0-6.61-5.468c-19.074-13.31-44.866-11.028-61.348 5.438-18.714 18.714-18.7 49.162 0.016 67.892 18.716 18.7 49.164 18.714 67.91-0.032 5.638-5.686 9.824-12.7 12.058-20.262 1.25-4.234 5.75-6.67 9.936-5.39a8 8 0 0 1 5.404 9.936c-2.982 10.092-8.542 19.418-16.074 27.01-12.496 12.498-28.916 18.746-45.318 18.746z"
                  fill=""></path>
                <path
                  d="M663.824 392.026c-8.466 0-16.464-3.312-22.494-9.342a31.76 31.76 0 0 1-9.376-22.666c0.016-17.636 14.374-31.978 31.994-31.978 4.42 0 7.998 3.578 7.998 7.998s-3.578 8-7.998 8c-8.81 0-15.98 7.17-15.996 15.996a15.768 15.768 0 0 0 4.686 11.326 15.768 15.768 0 0 0 11.248 4.67h0.078a15.952 15.952 0 0 0 11.874-5.326 8 8 0 0 1 11.902 10.684 31.922 31.922 0 0 1-23.728 10.638h-0.188z"
                  fill=""></path>
                <path
                  d="M663.95 368.03a8.002 8.002 0 0 1-7.81-6.31 8.024 8.024 0 0 1 6.138-9.514c281.864-60.692 345.6-302.204 345.6-344.116 0-4.42 3.578-8 8-8a7.994 7.994 0 0 1 7.998 8c0 43.914-66.064 296.844-358.222 359.752a8.1 8.1 0 0 1-1.704 0.188z"
                  fill=""></path>
                <path
                  d="M738.856 192.05a7.944 7.944 0 0 1-4.592-1.454 7.99 7.99 0 0 1-1.954-11.138C836.024 31.24 989.85 0.09 1015.908 0.09h0.016c4.42 0 7.998 3.578 7.998 8s-3.578 7.998-7.998 7.998h-0.016c-23.292 0-171.98 31.774-270.508 172.542a7.934 7.934 0 0 1-6.544 3.42zM312.1 607.95c-39.694-0.016-71.984-32.322-71.984-71.986 0-39.694 32.292-71.984 71.984-72 39.696 0.016 71.986 32.306 71.986 71.984s-32.292 71.986-71.986 72.002z m0-127.992c-30.868 0.016-55.988 25.136-55.988 56.004 0 30.854 25.122 55.974 55.988 55.99 30.87-0.016 55.99-25.136 55.99-56.006 0-30.866-25.122-55.972-55.99-55.988zM488.064 783.912c-39.696-0.016-71.986-32.322-71.986-71.984 0-39.696 32.292-71.986 71.986-72.002 39.696 0.016 71.984 32.306 71.984 72.002 0 39.662-32.288 71.968-71.984 71.984z m0-127.99c-30.87 0.016-55.988 25.136-55.988 56.006 0 30.854 25.12 55.972 55.988 55.988 30.868-0.016 55.988-25.134 55.988-55.988 0-30.87-25.12-55.99-55.988-56.006zM248.114 783.912a7.996 7.996 0 0 1-5.654-13.654l303.938-303.952a7.996 7.996 0 1 1 11.308 11.31L253.77 781.568a7.976 7.976 0 0 1-5.656 2.344z"
                  fill=""></path>
              </g>
            </svg>
            Adjust Fee/Apply a Discount
          </button>

          <button (click)="setWaive.set(true)" class="button waive" type="button">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M5 15L5.95039 4.54568C5.97849 4.23663 6.23761 4 6.54793 4H20.343C20.6958 4 20.9725 4.30295 20.9405 4.65432L20.0496 14.4543C20.0215 14.7634 19.7624 15 19.4521 15H5ZM5 15L4.4 21"
                  stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
              </g>
            </svg>
            Waive Fee
          </button>
        }

        @if (selectedStudentFee.status === 'WAIVED') {
          <button (click)="setReverseWaiver.set(true)" class="button waive" type="button">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M7.53033 3.46967C7.23744 3.17678 6.76256 3.17678 6.46967 3.46967L3.46967 6.46967C3.17678 6.76256 3.17678 7.23744 3.46967 7.53033L6.46967 10.5303C6.76256 10.8232 7.23744 10.8232 7.53033 10.5303C7.82322 10.2374 7.82322 9.76256 7.53033 9.46967L5.06066 7L7.53033 4.53033C7.82322 4.23744 7.82322 3.76256 7.53033 3.46967Z"
                      fill="#fff"></path>
                <path opacity="0.5"
                      d="M5.81066 6.25H15C18.1756 6.25 20.75 8.82436 20.75 12C20.75 15.1756 18.1756 17.75 15 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H15C17.3472 16.25 19.25 14.3472 19.25 12C19.25 9.65279 17.3472 7.75 15 7.75H5.81066L5.06066 7L5.81066 6.25Z"
                      fill="#fff"></path>
              </g>
            </svg>
            Reactivate Fee
          </button>
        }

      </div>
      }

    </div>
  </section>

  @if (admins.includes(loggedUserRole ?? '')) {

    @if (setDiscount()) {
      <section class="pop-up">
        <div class="bg" (click)="setDiscount.set(false)"></div>

        <form #discountForm="ngForm" (ngSubmit)="applyDiscount(discountForm)">
          <div class="form-heading">
            <div class="image-box">
              <svg viewBox="0 0 1024 1024" fill="#fff" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg"
                   stroke="#fff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M361.45 1023.91c-14.34 0-28.682-5.454-39.586-16.358L16.458 702.148c-21.84-21.84-21.84-57.348-0.016-79.172l441.16-441.158c20.48-20.48 59.956-31.526 88.092-24.636l206.536 50.646c24.588 6.062 49.332 27.854 60.19 53.004a7.998 7.998 0 0 1-4.17 10.514c-4.032 1.75-8.78-0.11-10.514-4.17-8.716-20.2-29.932-39.024-49.318-43.804L541.88 172.726c-22.886-5.624-56.3 3.75-72.968 20.402L27.754 634.288c-7.516 7.514-11.638 17.542-11.638 28.26 0 10.732 4.138 20.762 11.654 28.292l305.404 305.404c15.592 15.576 40.976 15.576 56.566-0.016l441.126-441.142c16.67-16.668 25.994-50.098 20.386-72.984l-37.336-152.266a8 8 0 0 1 5.858-9.686 8.008 8.008 0 0 1 9.672 5.876l37.336 152.264c7.014 28.588-3.796 67.298-24.606 88.106L401.05 1007.552c-10.92 10.906-25.274 16.358-39.6 16.358z"
                    fill=""></path>
                  <path
                    d="M663.934 423.986c-16.386 0-32.76-6.232-45.224-18.7-24.964-24.962-24.964-65.564-0.016-90.512 21.95-21.95 56.348-25.026 81.764-7.28a65.05 65.05 0 0 1 8.748 7.234 7.994 7.994 0 0 1 0.062 11.31c-3.11 3.138-8.17 3.186-11.308 0.078a48.916 48.916 0 0 0-6.61-5.468c-19.074-13.31-44.866-11.028-61.348 5.438-18.714 18.714-18.7 49.162 0.016 67.892 18.716 18.7 49.164 18.714 67.91-0.032 5.638-5.686 9.824-12.7 12.058-20.262 1.25-4.234 5.75-6.67 9.936-5.39a8 8 0 0 1 5.404 9.936c-2.982 10.092-8.542 19.418-16.074 27.01-12.496 12.498-28.916 18.746-45.318 18.746z"
                    fill=""></path>
                  <path
                    d="M663.824 392.026c-8.466 0-16.464-3.312-22.494-9.342a31.76 31.76 0 0 1-9.376-22.666c0.016-17.636 14.374-31.978 31.994-31.978 4.42 0 7.998 3.578 7.998 7.998s-3.578 8-7.998 8c-8.81 0-15.98 7.17-15.996 15.996a15.768 15.768 0 0 0 4.686 11.326 15.768 15.768 0 0 0 11.248 4.67h0.078a15.952 15.952 0 0 0 11.874-5.326 8 8 0 0 1 11.902 10.684 31.922 31.922 0 0 1-23.728 10.638h-0.188z"
                    fill=""></path>
                  <path
                    d="M663.95 368.03a8.002 8.002 0 0 1-7.81-6.31 8.024 8.024 0 0 1 6.138-9.514c281.864-60.692 345.6-302.204 345.6-344.116 0-4.42 3.578-8 8-8a7.994 7.994 0 0 1 7.998 8c0 43.914-66.064 296.844-358.222 359.752a8.1 8.1 0 0 1-1.704 0.188z"
                    fill=""></path>
                  <path
                    d="M738.856 192.05a7.944 7.944 0 0 1-4.592-1.454 7.99 7.99 0 0 1-1.954-11.138C836.024 31.24 989.85 0.09 1015.908 0.09h0.016c4.42 0 7.998 3.578 7.998 8s-3.578 7.998-7.998 7.998h-0.016c-23.292 0-171.98 31.774-270.508 172.542a7.934 7.934 0 0 1-6.544 3.42zM312.1 607.95c-39.694-0.016-71.984-32.322-71.984-71.986 0-39.694 32.292-71.984 71.984-72 39.696 0.016 71.986 32.306 71.986 71.984s-32.292 71.986-71.986 72.002z m0-127.992c-30.868 0.016-55.988 25.136-55.988 56.004 0 30.854 25.122 55.974 55.988 55.99 30.87-0.016 55.99-25.136 55.99-56.006 0-30.866-25.122-55.972-55.99-55.988zM488.064 783.912c-39.696-0.016-71.986-32.322-71.986-71.984 0-39.696 32.292-71.986 71.986-72.002 39.696 0.016 71.984 32.306 71.984 72.002 0 39.662-32.288 71.968-71.984 71.984z m0-127.99c-30.87 0.016-55.988 25.136-55.988 56.006 0 30.854 25.12 55.972 55.988 55.988 30.868-0.016 55.988-25.134 55.988-55.988 0-30.87-25.12-55.99-55.988-56.006zM248.114 783.912a7.996 7.996 0 0 1-5.654-13.654l303.938-303.952a7.996 7.996 0 1 1 11.308 11.31L253.77 781.568a7.976 7.976 0 0 1-5.656 2.344z"
                    fill=""></path>
                </g>
              </svg>
            </div>

            <div>
              <h6>Update Fee</h6>
              <small>Apply a discount or adjustment to {{ selectedStudentFee.fee_name }}</small>
            </div>
          </div>

          <div class="form-container">

            <div>
              <label for="discountAmount">Discount(%) <span class="required-check">*</span></label>
              <input [required]="!adjustmentAmount" max="100" placeholder="15%" [(ngModel)]="discountAmount"
                     type="number" name="discountAmount" id="discountAmount">
            </div>

            <div>
              <label for="adjustmentAmount">Adjustment Amount (GH₵)</label>
              <small class="negative-amount">*Use a negative amount if adjustment is a reduction</small>
              <input [max]="selectedStudentFee.final_amount" placeholder="0.00" [(ngModel)]="adjustmentAmount"
                     type="number" name="adjustmentAmount" id="adjustmentAmount">
            </div>

            @if (adjustmentAmount && adjustmentAmount !== 0) {
              <div>
                <label for="adjustmentReason">Adjustment Reason <span class="required-check">*</span></label>
                <textarea required placeholder="Provide a reason for this adjustment..." cols="30" rows="3"
                          [(ngModel)]="adjustmentReason" type="text" name="adjustmentReason"
                          id="adjustmentReason"></textarea>
              </div>
            }
            <button [disabled]="discountForm.invalid" class="secondary-button">
              @if (isSubmitting()) {
                <app-loading-indicator />
              } @else {
                Confirm
              }
            </button>
          </div>
        </form>
      </section>
    }

    @if (setWaive()) {
      <section class="pop-up">
        <div class="bg" (click)="setWaive.set(false)"></div>

        <form #waiveForm="ngForm" (ngSubmit)="waiveFee(waiveForm)">
          <div class="form-heading">
            <div class="image-box">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M5 15L5.95039 4.54568C5.97849 4.23663 6.23761 4 6.54793 4H20.343C20.6958 4 20.9725 4.30295 20.9405 4.65432L20.0496 14.4543C20.0215 14.7634 19.7624 15 19.4521 15H5ZM5 15L4.4 21"
                    stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
              </svg>
            </div>

            <div>
              <h6>Waive Fee</h6>
              <small>Waive fee of GH₵{{ selectedStudentFee.final_amount }}
                for {{ student()?.payload?.first_name }} {{ student()?.payload?.last_name }}</small>
            </div>
          </div>

          <div class="form-container">

            <div>
              <label for="waiveReason">Reason for Waiver <span class="required-check">*</span></label>

              <textarea required [(ngModel)]="waiveReason" placeholder="Provide a clear reason for waiving this fee..."
                        name="waiveReason" id="waiveReason" cols="30" rows="3"></textarea>
            </div>

            <button [disabled]="waiveForm.invalid" class="secondary-button">
              @if (isSubmitting()) {
                <app-loading-indicator />
              } @else {
                Waive Fee
              }
            </button>
          </div>
        </form>
      </section>
    }

    @if (setReverseWaiver()) {
      <section class="pop-up">
        <div class="bg" (click)="setReverseWaiver.set(false)"></div>

        <form #reverseWaiverForm="ngForm" (ngSubmit)="reverseWaiver(reverseWaiverForm)">
          <div class="form-heading">
            <div class="image-box">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M7.53033 3.46967C7.23744 3.17678 6.76256 3.17678 6.46967 3.46967L3.46967 6.46967C3.17678 6.76256 3.17678 7.23744 3.46967 7.53033L6.46967 10.5303C6.76256 10.8232 7.23744 10.8232 7.53033 10.5303C7.82322 10.2374 7.82322 9.76256 7.53033 9.46967L5.06066 7L7.53033 4.53033C7.82322 4.23744 7.82322 3.76256 7.53033 3.46967Z"
                        fill="#fff"></path>
                  <path opacity="0.5"
                        d="M5.81066 6.25H15C18.1756 6.25 20.75 8.82436 20.75 12C20.75 15.1756 18.1756 17.75 15 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H15C17.3472 16.25 19.25 14.3472 19.25 12C19.25 9.65279 17.3472 7.75 15 7.75H5.81066L5.06066 7L5.81066 6.25Z"
                        fill="#fff"></path>
                </g>
              </svg>
            </div>

            <div>
              <h6>Reverse Waiver</h6>
              <small>Reactivate fee of GH₵{{ selectedStudentFee.final_amount }}
                for {{ student()?.payload?.first_name }} {{ student()?.payload?.last_name }}</small>
            </div>
          </div>

          <div class="form-container">

            <div>
              <label for="reversalReason">Reason for Reversal <span class="required-check">*</span></label>

              <textarea required [(ngModel)]="reversalReason"
                        placeholder="Provide a clear reason for reversing this waiver..."
                        name="reversalReason" id="reversalReason" cols="30" rows="3"></textarea>
            </div>

            <button [disabled]="reverseWaiverForm.invalid" class="secondary-button">
              @if (isSubmitting()) {
                <app-loading-indicator />
              } @else {
                Reverse Waiver
              }
            </button>
          </div>
        </form>
      </section>
    }

    @if (setRecordPayment()) {
      <section class="pop-up">
        <div class="bg" (click)="setRecordPayment.set(false)"></div>

        <form #paymentForm="ngForm" (ngSubmit)="recordPayment(paymentForm)">
          <div class="form-heading">
            <div class="image-box">
              <svg version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink"
                   viewBox="0 0 32 32" xml:space="preserve" fill="#fff" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0 {
                  fill: none;
                  stroke: #fff;
                  stroke-width: 2;
                  stroke-linecap: round;
                  stroke-linejoin: round;
                  stroke-miterlimit: 10;
                } </style>
                  <path
                    d="M24,16c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S28.4,16,24,16z M27,25h-2v2c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2h-2 c-0.6,0-1-0.4-1-1s0.4-1,1-1h2v-2c0-0.6,0.4-1,1-1s1,0.4,1,1v2h2c0.6,0,1,0.4,1,1S27.6,25,27,25z"></path>
                  <g> <path
                    d="M16,11c-2.2,0-4,2.2-4,5c0,2.1,1.1,3.9,2.6,4.7c0.9-2.6,2.8-4.7,5.3-5.8C19.5,12.7,17.9,11,16,11z"></path>
                    <path
                      d="M31,5H1C0.4,5,0,5.4,0,6v20c0,0.6,0.4,1,1,1h13.5c-0.3-0.9-0.5-2-0.5-3H7c-0.6,0-1-0.4-1-1c0-1.1-0.9-2-2-2 c-0.6,0-1-0.4-1-1v-8c0-0.6,0.4-1,1-1c1.1,0,2-0.9,2-2c0-0.6,0.4-1,1-1h18c0.6,0,1,0.4,1,1c0,1.1,0.9,2,2,2c0.6,0,1,0.4,1,1v3.4 c1.2,0.7,2.2,1.6,3,2.7V6C32,5.4,31.6,5,31,5z"></path> </g> </g></svg>
            </div>

            <div>
              <h6>Record Payment</h6>
              <small>Record a payment for {{ selectedStudentFee.fee_name }}</small>
            </div>
          </div>

          <div class="form-container">

            <div class="user-card">
              <div class="heading">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="white">
                  <rect x="2" y="6" width="20" height="12" rx="2" stroke-width="1.5" />
                  <circle cx="12" cy="12" r="2.5" stroke-width="1.5" />
                  <path d="M6 9H6.01M18 15H18.01" stroke-width="2" stroke-linecap="round" />
                </svg>
                <h4>Selected Fee</h4>
              </div>

              <div class="user-content">
                <p>FEE NAME</p>
                <p>FINAL AMOUNT</p>

                <h5>{{ selectedStudentFee.fee_name }}</h5>
                <h5>GH₵{{ selectedStudentFee.final_amount }}</h5>
              </div>
            </div>

            @if (paymentRemainingBalance !== null) {
              <div class="note">

                <div class="shield-box"><img src="/auth/warning-icon.png" alt="warning image"></div>
                <div>
                  <h6>Cannot pay more than the Remaining Balance.</h6>
                  <p>Remaining Balance: <span>GH₵{{ paymentRemainingBalance }}.</span></p>
                </div>
              </div>
            }

            <div>
              <label for="paymentAmount">Amount (GH₵) <span class="required-check">*</span></label>
              <input required type="number" name="paymentAmount" id="paymentAmount"
                     [max]="paymentRemainingBalance ?? 100000" [(ngModel)]="paymentAmount"
                     placeholder="e.g. 450.50">
            </div>

            <div>
              <label for="paymentDate">Payment Date <span class="required-check">*</span></label>
              <input required type="date" name="paymentDate" id="paymentDate" [(ngModel)]="paymentDate">
            </div>

            <div>
              <label for="paymentMethod">Payment Method <span class="required-check">*</span></label>
              <select required name="paymentMethod" id="paymentMethod" [(ngModel)]="paymentMethod">
                <option value="">Choose a payment method</option>

                @for (p of paymentMethods; track $index) {
                  <option [value]="p">{{ Helpers.capitalizeWords(Helpers.replaceUnderscore(p)) }}</option>
                }
              </select>
            </div>

            <div>
              <label for="transactionReference">Transaction Reference</label>
              <input type="text" placeholder="e.g. 48522..." name="transactionReference" id="transactionReference"
                     [(ngModel)]="transactionReference">
            </div>

            <div>
              <label for="additionalNotes">Additional Notes</label>
              <textarea name="additionalNotes" id="additionalNotes" cols="30" rows="2"
                        [(ngModel)]="additionalNotes" placeholder="add relevant notes..."></textarea>
            </div>

            <button [disabled]="paymentForm.invalid || isPaymentOverLimit" class="secondary-button" type="submit">
              @if (isSubmitting()) {
                <app-loading-indicator />
              } @else {
                Record Payment
              }
            </button>
          </div>
        </form>
      </section>
    }
  }

  @if (setAssignFee()) {
    <section class="pop-up">
      <div class="bg" (click)="closeAssignFee()"></div>

      <form #assignFeeForm="ngForm" (ngSubmit)="assignFee(assignFeeForm)">
        <div class="form-heading">
          <div class="image-box">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="6" width="20" height="12" rx="2" stroke="white" stroke-width="1.5" />
              <circle cx="12" cy="12" r="2.5" stroke="white" stroke-width="1.5" />
              <path d="M6 9H6.01M18 15H18.01" stroke="white" stroke-width="2" stroke-linecap="round" />
            </svg>
          </div>

          <div>
            <h6>Assign Fee</h6>
            <small>Assign a fee to {{ student()?.payload?.first_name }} {{ student()?.payload?.last_name }}</small>
          </div>
        </div>

        <div class="form-container">
          <div class="user-query">
            <label for="feeQuery">Search Fee <span class="required-check">*</span></label>
            <input (input)="getFeesToAssign(feeQuery)" [(ngModel)]="feeQuery" type="search" name="feeQuery"
                   id="feeQuery" placeholder="Search for a fee...">

            @if (feeStructuresToAssign()?.payload?.length && feeQuery !== '') {
              <ul>

                @for (f of feeStructuresToAssign()?.payload; track $index) {
                  @if (f.status === 'ACTIVE') {
                    <li (click)="selectFeeToAssign(f)">
                      <h6>{{ f.fee_name }}</h6>
                      <p>GH₵{{ f.amount }}</p>
                    </li>
                  }
                }

              </ul>
            }
          </div>

          @if (selectedFee) {
            <div class="user-card">
              <div class="heading">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="white">
                  <rect x="2" y="6" width="20" height="12" rx="2" stroke-width="1.5" />
                  <circle cx="12" cy="12" r="2.5" stroke-width="1.5" />
                  <path d="M6 9H6.01M18 15H18.01" stroke-width="2" stroke-linecap="round" />
                </svg>
                <h4>Selected Fee</h4>
              </div>

              <div class="user-content">
                <p>FEE NAME</p>
                <p>AMOUNT</p>

                <h5>{{ selectedFee.fee_name }}</h5>
                <h5>GH₵{{ selectedFee.amount }}</h5>
              </div>
            </div>
          }

          <div>
            <label for="discountAmount">Discount (%)</label>
            <input [max]="selectedFee?.amount ?? null" placeholder="5%" [(ngModel)]="discountAmount" type="number"
                   name="discountAmount" id="discountAmount">
          </div>

          <div>
            <label for="adjustmentAmount">Adjustment Amount (GH₵)</label>
            <small class="negative-amount">*Can accept a negative amount</small>
            <input [max]="selectedFee?.amount ?? null" placeholder="0.00" [(ngModel)]="adjustmentAmount" type="number"
                   name="adjustmentAmount" id="adjustmentAmount">
          </div>

          @if (adjustmentAmount && adjustmentAmount > 0) {
            <div>
              <label for="adjustmentReason">Adjustment Reason</label>
              <textarea required placeholder="Provide a reason for this adjustment..." cols="30" rows="3"
                        [(ngModel)]="adjustmentReason" type="text" name="adjustmentReason"
                        id="adjustmentReason"></textarea>
            </div>
          }

          <button [disabled]="assignFeeForm.invalid || !selectedFee || !selectedFeeStructure()?.payload?.length"
                  class="secondary-button" type="submit">
            @if (isSubmitting()) {
              <app-loading-indicator />
            } @else {
              Assign Fee
            }
          </button>

        </div>
      </form>
    </section>
  }

}

@if (schoolAdmins.includes(loggedUserRole ?? '')) {
  @if (assignClassCheck()) {
    <section class="pop-up">
      <div class="bg" (click)="assignClassCheck.set(false)"></div>

      <form #assignClassForm="ngForm" (ngSubmit)="assignStudentToClass(assignClassForm)">
        <div class="form-heading">
          <div class="image-box">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.4865 13.1108V11.8622C12.4865 11.1998 12.2234 10.5646 11.7551 10.0963C11.2867 9.62798 10.6515 9.36487 9.98921 9.36487H4.99461C4.33229 9.36487 3.69709 9.62798 3.22876 10.0963C2.76042 10.5646 2.49731 11.1998 2.49731 11.8622V13.1108"
                stroke="white" stroke-width="1.37352" />
              <path
                d="M7.49193 6.86759C8.87115 6.86759 9.98923 5.74951 9.98923 4.37029C9.98923 2.99107 8.87115 1.87299 7.49193 1.87299C6.11271 1.87299 4.99463 2.99107 4.99463 4.37029C4.99463 5.74951 6.11271 6.86759 7.49193 6.86759Z"
                stroke="white" stroke-width="1.37352" />
            </svg>
          </div>

          <div>
            <h6>Assign Student to a Class</h6>
            <small>{{ student()?.payload?.first_name }} {{ student()?.payload?.last_name }} will belong to this
              class</small>
          </div>
        </div>

        <div class="form-container">
          <div>
            <label for="academicYearId">Academic Year <span class="required-check">*</span></label>
            <select (change)="onAcademicYearChange()" required [(ngModel)]="academicYearId"
                    name="academicYearId" id="academicYearId">
              <option value="">Select an academic year</option>

              @for (a of academicYears()?.payload; track a.id) {
                <option [value]="a.id">{{ a.name }}</option>
              }
            </select>
          </div>

          <div>
            <label for="classId">Class <span class="required-check">*</span></label>
            <select required (change)="selectClassById(classId)" [(ngModel)]="classId" name="classId"
                    id="classId">
              <option value="" disabled>Select a class</option>

              @if (classes()?.payload?.length) {
                @for (c of classes()?.payload; track c.id) {
                  @if (!invalidStatuses.includes(c.status)) {
                    <option [value]="c.id">{{ c.level_name }}{{ c.name }}</option>
                  }
                }
              }
            </select>
          </div>

          <div>
            <label for="startDate">Start Date <span class="required-check">*</span></label>
            <input required [disabled]="academicYear() !== null" [(ngModel)]="startDate" type="date" name="startDate"
                   id="startDate">
          </div>

          <div>
            <label for="endDate">End Date <span class="required-check">*</span></label>
            <input required [disabled]="academicYear() !== null" [(ngModel)]="endDate" type="date" name="endDate"
                   id="endDate">
          </div>

          <div>
            <label for="enrollmentDate">Date Enrolled <span class="required-check">*</span></label>
            <input required [(ngModel)]="enrollmentDate" type="date" name="enrollmentDate" id="enrollmentDate">
          </div>

          @if (academicYear() !== null) {
            <div class="note">

              <div class="shield-box"><img src="/auth/warning-icon.png" alt="warning image"></div>

              <div>
                <p>Start & End dates must fall strictly within the boundaries of the parent Academic Year
                  ({{ Helpers.formatDate(academicYear()?.payload?.start_date) }}
                  - {{ Helpers.formatDate(academicYear()?.payload?.end_date) }}).</p>
              </div>
            </div>
          }

          <button [disabled]="assignClassForm.invalid || !classId" class="secondary-button" type="submit">
            @if (isSubmitting()) {
              <app-loading-indicator />
            } @else {
              Assign Student
            }
          </button>

        </div>
      </form>
    </section>
  }
}
